import { ObjectDefinition } from '../types';

export const DEVICE_DEFINITIONS: ObjectDefinition[] = [
  {
    type: 'temperature-sensor',
    name: 'Temperature Sensor',
    icon: '🌡️',
    category: 'Sensors',
    description: 'Measures ambient temperature',
    defaultProperties: {
      deviceType: 'temperature-sensor',
      status: 'online',
      color: '#ff6b6b',
      data: {
        value: 22,
        unit: '°C',
        timestamp: new Date(),
      },
    },
  },
  {
    type: 'humidity-sensor',
    name: 'Humidity Sensor',
    icon: '💧',
    category: 'Sensors',
    description: 'Measures relative humidity',
    defaultProperties: {
      deviceType: 'humidity-sensor',
      status: 'online',
      color: '#4ecdc4',
      data: {
        value: 65,
        unit: '%',
        timestamp: new Date(),
      },
    },
  },
  {
    type: 'motion-sensor',
    name: 'Motion Sensor',
    icon: '🏃',
    category: 'Sensors',
    description: 'Detects movement and presence',
    defaultProperties: {
      deviceType: 'motion-sensor',
      status: 'online',
      color: '#45b7d1',
      data: {
        value: 0,
        unit: 'detected',
        timestamp: new Date(),
      },
    },
  },
  {
    type: 'pressure-sensor',
    name: 'Pressure Sensor',
    icon: '🎯',
    category: 'Sensors',
    description: 'Measures atmospheric pressure',
    defaultProperties: {
      deviceType: 'pressure-sensor',
      status: 'online',
      color: '#f9ca24',
      data: {
        value: 1013,
        unit: 'hPa',
        timestamp: new Date(),
      },
    },
  },
  {
    type: 'camera',
    name: 'Security Camera',
    icon: '📷',
    category: 'Devices',
    description: 'Video surveillance camera',
    defaultProperties: {
      deviceType: 'camera',
      status: 'online',
      color: '#6c5ce7',
    },
  },
  {
    type: 'gateway',
    name: 'IoT Gateway',
    icon: '📡',
    category: 'Devices',
    description: 'Central communication hub',
    defaultProperties: {
      deviceType: 'gateway',
      status: 'online',
      color: '#a29bfe',
    },
  },
  {
    type: 'actuator',
    name: 'Actuator',
    icon: '⚙️',
    category: 'Devices',
    description: 'Controls physical systems',
    defaultProperties: {
      deviceType: 'actuator',
      status: 'online',
      color: '#fd79a8',
    },
  },
];

export const PRIMITIVE_DEFINITIONS: ObjectDefinition[] = [
  {
    type: 'box',
    name: 'Box',
    icon: '📦',
    category: 'Primitives',
    description: 'Basic rectangular shape',
    defaultProperties: {
      geometry: 'box',
      material: {
        color: '#95a5a6',
        metalness: 0.1,
        roughness: 0.8,
      },
    },
  },
  {
    type: 'sphere',
    name: 'Sphere',
    icon: '⚪',
    category: 'Primitives',
    description: 'Basic spherical shape',
    defaultProperties: {
      geometry: 'sphere',
      material: {
        color: '#95a5a6',
        metalness: 0.1,
        roughness: 0.8,
      },
    },
  },
  {
    type: 'cylinder',
    name: 'Cylinder',
    icon: '🥫',
    category: 'Primitives',
    description: 'Basic cylindrical shape',
    defaultProperties: {
      geometry: 'cylinder',
      material: {
        color: '#95a5a6',
        metalness: 0.1,
        roughness: 0.8,
      },
    },
  },
  {
    type: 'plane',
    name: 'Plane',
    icon: '▬',
    category: 'Primitives',
    description: 'Flat rectangular surface',
    defaultProperties: {
      geometry: 'plane',
      material: {
        color: '#bdc3c7',
        metalness: 0.0,
        roughness: 1.0,
      },
    },
  },
];

export const BUILDING_DEFINITIONS: ObjectDefinition[] = [
  {
    type: 'wall',
    name: 'Wall',
    icon: '🧱',
    category: 'Building',
    description: 'Structural wall element',
    defaultProperties: {
      geometry: 'box',
      material: {
        color: '#ecf0f1',
        metalness: 0.0,
        roughness: 0.9,
      },
    },
  },
  {
    type: 'door',
    name: 'Door',
    icon: '🚪',
    category: 'Building',
    description: 'Entry/exit door',
    defaultProperties: {
      geometry: 'box',
      material: {
        color: '#8b4513',
        metalness: 0.1,
        roughness: 0.7,
      },
    },
  },
  {
    type: 'window',
    name: 'Window',
    icon: '🪟',
    category: 'Building',
    description: 'Glass window',
    defaultProperties: {
      geometry: 'box',
      material: {
        color: '#87ceeb',
        metalness: 0.9,
        roughness: 0.1,
        transparent: true,
        opacity: 0.3,
      },
    },
  },
];

export const ALL_OBJECT_DEFINITIONS = [...DEVICE_DEFINITIONS, ...PRIMITIVE_DEFINITIONS, ...BUILDING_DEFINITIONS];

export const OBJECT_CATEGORIES = [
  { name: 'Sensors', items: DEVICE_DEFINITIONS.filter((d) => d.category === 'Sensors') },
  { name: 'Devices', items: DEVICE_DEFINITIONS.filter((d) => d.category === 'Devices') },
  { name: 'Primitives', items: PRIMITIVE_DEFINITIONS },
  { name: 'Building', items: BUILDING_DEFINITIONS },
];

export const getObjectDefinition = (type: string): ObjectDefinition | null => {
  return ALL_OBJECT_DEFINITIONS.find((def) => def.type === type) || null;
};

export const getObjectsByCategory = (category: string): ObjectDefinition[] => {
  return ALL_OBJECT_DEFINITIONS.filter((def) => def.category === category);
};
